import { render, staticRenderFns } from "./kdbav.vue?vue&type=template&id=2bebe856&"
import script from "./kdbav.vue?vue&type=script&lang=js&"
export * from "./kdbav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports